<template>
  <div class="content-item mb8 clearFloat">
    <cx-background :background.sync="background" imgType="10" class="mt16" />
  </div>
</template>

<script>
import { historyIgnoreWrap } from "utils/revork"
export default {
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      defaultBgImage: require("assets/images/default_image.png"),
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ]
    }
  },
  computed: {
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        historyIgnoreWrap(() => {
          this.$emit("update", "background", newBackground)
        })()
        return newBackground
      },
      set(newVal) {
        this.$emit("update", "background", newVal)
      }
    }
  },
  methods: {
    reset() {
      this.$emit("update", "bgColor", "#00043A")
      this.$emit("update", "bgColorType", "纯色")
    }
  }
}
</script>

<style scoped>
.flex_type {
  justify-content: space-between;
}
</style>
